module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"csvExports":"CSV Exports"},"fr":{"csvExports":"Exports CSV"}}')
  delete Component.options._Ctor
}
